import { connect } from 'react-redux';
import { submit, change as changeFormValue } from 'redux-form';
import { constants } from '@eti/utils';
import { CHECK_IN_BAGGAGE } from '../../../products';
import CheckInBaggagePrimaryFlowPersuasionModal from '../components/CheckInBaggagePrimaryFlowPersuasionModal';
import PersuasionModalProvider from '../../../common/context/PersuasionModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
const productName = CHECK_IN_BAGGAGE.name;
const setCheckedBaggageChoiceValueForTraveler = (dispatch, _ref) => {
  let {
    sellSpecification
  } = _ref;
  return (form, traveler, value) => {
    var _sellSpecification$se, _sellSpecification$se2;
    const {
      id,
      markup,
      price
    } = traveler;
    const {
      maxWeight: weight,
      numberOfUnits: numberOfPieces,
      weightUnit
    } = (_sellSpecification$se = sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$se2 = sellSpecification.sellPriceBaggage) === null || _sellSpecification$se2 === void 0 ? void 0 : _sellSpecification$se2[0]) !== null && _sellSpecification$se !== void 0 ? _sellSpecification$se : {};
    const formattedValue = value === 'true';
    dispatch(changeFormValue(form, `${productName}.${productName}-traveler-${id}`, {
      value: value !== null && value !== void 0 ? value : null,
      id,
      markup: formattedValue ? markup : null,
      priceRaw: formattedValue ? price !== null && price !== void 0 ? price : 0 : 0,
      numberOfPieces,
      weight,
      weightUnit
    }));
  };
};
const PersuasionModalWrapper = _ref2 => {
  let {
    submitForm,
    triggerChange
  } = _ref2;
  return /*#__PURE__*/_jsx(PersuasionModalProvider, {
    children: /*#__PURE__*/_jsx(CheckInBaggagePrimaryFlowPersuasionModal, {
      submitForm: submitForm,
      triggerChange: triggerChange
    })
  });
};
const triggerChange = (dispatch, props) => value => {
  const {
    form,
    sellSpecification,
    shouldApplySelectionToAll,
    order
  } = props;
  if (shouldApplySelectionToAll) {
    order === null || order === void 0 || order.travelers.forEach(traveler => {
      if (traveler.ageType !== constants.ageTypes.INFANT) {
        setCheckedBaggageChoiceValueForTraveler(dispatch, {
          sellSpecification
        })(form, traveler, value);
      }
    });
  }
};
const mapDispatchToProps = (dispatch, props) => {
  const {
    form,
    sellSpecification,
    shouldApplySelectionToAll,
    order
  } = props;
  return {
    triggerChange: triggerChange(dispatch, {
      form,
      sellSpecification,
      shouldApplySelectionToAll,
      order
    }),
    submitForm() {
      dispatch(submit(form));
    }
  };
};
export default connect(null, mapDispatchToProps)(PersuasionModalWrapper);